import { apolloClient } from '@/apollo/client'
import { GLOBAL_REPORTS_QUERY } from '@/graphql/globalReport/globalReports'

export const GlobalReportService = {
    all (variables, options) {
        const queryOptions = {
            query: GLOBAL_REPORTS_QUERY,
            variables,
        }
        if (options?.abortController) {
            queryOptions.context = {
                fetchOptions: {
                    signal: options.abortController.signal,
                },
            }
        }
        return apolloClient.query(queryOptions).then(response => response.data.globalReports)
    },
}
